import styled from 'styled-components';

import { ModalContent } from 'components/modal';

export const HeaderCaption = styled.div`
  color: ${Styles.color.black};
  font-weight: normal;
  letter-spacing: 0;
  text-align: center;
  padding-top: 2rem;
  h2 {
    font-family: ${Styles.fontFamily.base};
    margin: 0.75rem 0 0;
    text-transform: uppercase;
  }
  h5 {
    font-family: ${Styles.fontFamily.body};
    margin: 0;
    text-transform: none;
  }
  ${Styles.desktop`
    line-height: 1;
  `}
`;

export const GeolocationImageContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.5rem 0rem;
  width: 50px;
  height: 80px;
`;

export const ContentContainer = styled(ModalContent)`
  font-size: 1rem;

  & div.modal-inner {
    max-width: none;
    margin: 0;
    width: 100%;
    text-align: center;
    padding: 0 1.5rem;
    ${Styles.desktop`
      padding: 3rem 15% 2rem;
    `}
  }

  & div.modal-scroller {
    padding-top: 3rem;
    ${Styles.desktop`
      padding: 0;
    `}
  }
`;
